<template>
    <div>
        <div style="margin-bottom:20px">
            <el-alert :show-icon="false"
                title="温馨提示，请按照下列指定的元素修改信息，并且使用最终分支名称来对分支进行命名"
                center
                type="error">
            </el-alert>
            </div>
        <el-form ref="form" label-width="80px">
            <el-form-item label="最终名称" v-if="!isPrBranch">
                <el-col :span="6" >
                    <el-tag type="primary">{{gitBranch.prefix}}-{{gitBranch.area}}-{{gitBranch.name}}-{{gitBranch.branchName}}-{{gitBranch.version}}</el-tag>
                </el-col>
            </el-form-item>

            <el-form-item label="最终名称" v-else="isPrBranch">
                <el-col :span="6" >
                    <el-tag type="primary">{{gitBranch.prefix}}-{{gitBranch.area}}-{{gitBranch.env}}-{{gitBranch.branchName}}-{{gitBranch.version}}</el-tag>
                </el-col>
            </el-form-item>

            <el-form-item label="分支类型">
            <el-col :span="6">
                <el-select v-model="gitBranch.branchType" @change="builder" placeholder="请选择">
                    <el-option
                        v-for="b in branchTypes"
                        :key="b.value"
                        :label="b.label"
                        :value="b.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="所在地域">
            <el-col :span="6">
                <el-select v-model="gitBranch.area" placeholder="请选择">
                    <el-option
                        v-for="area in areas"
                        :key="area.value"
                        :label="area.label"
                        :value="area.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="环境分支" v-if="isPrBranch">
            <el-col :span="6">
                <el-select v-model="gitBranch.env" placeholder="请选择">
                    <el-option
                        v-for="env in envs"
                        :key="env.value"
                        :label="env.label"
                        :value="env.value"
                    >
                    </el-option>
                </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="分支前缀">
            <el-col :span="6">
              <el-input :readonly="!gitBranch.isCustomerPrefix" placeholder="用来标识分支属性的，功能分支还是BUG修正分支"  v-model="gitBranch.prefix"></el-input>
            </el-col>
          </el-form-item>  
          <el-form-item label="姓名简写" v-if="!isPrBranch">
            <el-col :span="6">
                <el-input v-model="gitBranch.name" placeholder="开发人员姓名的简拼缩写"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="分支名称">
            <el-col :span="6">
              <el-input v-model="gitBranch.branchName" placeholder="分支名称自定义，推荐使用模块名称"></el-input>
            </el-col>
          </el-form-item>  
          <el-form-item label="版本号：">
            <el-col :span="6">
              <el-input v-model="gitBranch.version" placeholder="建议版本号同产品原型版本号保持一致"></el-input>
            </el-col>
          </el-form-item>
          
          
        </el-form>
    </div>
  </template>

  <script>
    import FormComponents from "@/components/form/FormComponents";
    export default {
        name: "GitBranchTool",
        components: {
            FormComponents,
        },
        data() {
            return {
                gitBranch:{
                    version:"1.0.0",
                    branchType:"feature",
                    prefix:"feature",
                    branchName:"moduleName",
                    area:"chengdu",
                    name:"hcs",
                    isCustomerPrefix:false,
                    isPrBranch:false,
                    env:""
                },
                branchTypes:[
                    {
                        value: "feature",
                        label: "常规开发功能分支",
                    },
                    {
                        value: "fix",
                        label: "BUG修复分支",
                    },
                    {
                        value: "pr",
                        label: "代码PR合并分支",
                    },
                    {
                        value: "temp",
                        label: "临时分支",
                    },
                    {
                        value: "other",
                        label: "其他分支",
                    }
                ],
                areas:[
                    {
                        value: "chengdu",
                        label: "成都研发中心",
                    },
                    {
                        value: "xian",
                        label: "西安研发中心",
                    },
                    {
                        value: "urumqi",
                        label: "乌鲁木齐研发中心",
                    }
                ],
                envs:[
                    {
                        value: "test",
                        label: "测试环境",
                    },
                    {
                        value: "release",
                        label: "生产环境",
                    }
                ]
            }
        },
        methods:{
            builder(val){
                if(val=="other"){
                    this.gitBranch.isCustomerPrefix = true
                    this.gitBranch.prefix=""
                    this.isPrBranch = false
                }else if(val=="pr"){
                    this.gitBranch.prefix = val;
                    this.isPrBranch = true
                    this.gitBranch.env="test"
                }else{
                    this.gitBranch.prefix = val;
                    this.gitBranch.isCustomerPrefix = false
                    this.isPrBranch = false
                }
            },
        }
    }
  </script>